if (!customElements.get('color-gallery-slider')) {
  customElements.define(
    'color-gallery-slider',
    class ColorGallerySlider extends HTMLElement {
      connectedCallback() {
        // Does NOT have 'swiper' class yet — added in JS so third-party apps
        // that scan for '.swiper' on page load won't accidentally pick it up
        this.swiperEl = this.querySelector('.color-gallery__swiper-inner');
        if (!this.swiperEl) return;

        this.initSlider();

        document.addEventListener('shopify:section:load', (e) => {
          if (e.target.contains(this)) this.initSlider();
        });
      }

      initSlider() {
        if (this.sliderInstance) {
          this.sliderInstance.slider.destroy();
          this.sliderInstance = null;
        }

        this.swiperEl.classList.add('swiper');

        const loop = this.dataset.loop === 'true';
        const autoplayDelay = parseInt(this.dataset.autoplayDelay || 0);
        const desktopCols = parseInt(this.dataset.desktopCols || 3);

        const options = {
          slidesPerView: 1,
          spaceBetween: 12,
          loop: loop,
          grabCursor: true,
          threshold: 2,
          breakpoints: {
            768: {
              slidesPerView: Math.min(2, desktopCols),
              spaceBetween: 16,
            },
            1024: {
              slidesPerView: desktopCols,
              spaceBetween: 20,
            },
          },
          navigation: {
            prevEl: this.querySelector('.color-gallery__btn-prev'),
            nextEl: this.querySelector('.color-gallery__btn-next'),
          },
          pagination: {
            el: this.querySelector('.color-gallery__pagination'),
            clickable: true,
          },
        };

        if (autoplayDelay > 0) {
          options.autoplay = {
            delay: autoplayDelay,
            disableOnInteraction: false,
          };
        }

        this.sliderInstance = new window.FoxTheme.Carousel(this.swiperEl, options);
        this.sliderInstance.init();
      }
    }
  );
}
